module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/annonces-app-modules/~/axios/index.js
// module id = 85
// module chunks = 0